import { DateFormat } from '../Format';

const MESSAGES = {
    now () {
        return '방금';
    },
    minutes (diff) {
        return `${Math.floor(diff / 60)}분전`;
    },
    hours (diff) {
        return `${Math.floor(diff / 3600)}시간전`;
    },
    date (timestamp) {
        const time = new Date(timestamp);
        return DateFormat(time, 'N dd. yyyy');
    // return B.Util.dateFormat(time, 'N dd. yyyy');
    },
};

export const BrunchDate = (timestamp) => {
    const nowTimestamp = (new Date()).getTime();
    const diff = (nowTimestamp - timestamp) / 1000;

    if (diff < 60) {
        return MESSAGES.now();
    }

    if (diff < 3600) {
        return MESSAGES.minutes(diff);
    }

    if (diff < 34560) {
        return MESSAGES.hours(diff);
    }

    return MESSAGES.date(timestamp);
};


export const parseDate = (data) => {
    const date = new Date(data);
    const year = date.getFullYear().toString();

    const month = (date.getMonth() + 1).toString();
    let fullMonth = month;

    if (fullMonth.length < 2) {
        fullMonth = `0${month}`;
    }

    const day = date.getDate().toString();
    let fullDay = day;

    if (fullDay.length < 2) {
        fullDay = `0${fullDay}`;
    }

    const h = date.getHours();
    let simpleHour = h;

    if (h > 12 && h < 24) {
        simpleHour = h - 12;
    }

    let koDayNight = '오전';

    if (h >= 12 && h < 24) {
        koDayNight = '오후';
    }

    const koHour = `${koDayNight} ${simpleHour}시`;

    return {
        fullYear: year,
        simpleYear: year.substring(2, 5),
        fullMonth,
        month,
        fullDay,
        day,
        koHour,
    };
};
